module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABM0lEQVQ4jY3TSyvFQRjH8Y//OcjLIOVW7NjZILe8hbM6xQLlLdgqtygKeRPKgpWl2LiUjZJkbSF1XLKY+WvO6TidX03/md//+T4zPfNMS+vxqhr1o4xpdEbvEac4wH0anCXzNuzgBivoRXscfdG7wR46cqiYwCcYrz1OjTLMoxszqOQn2GgCTjWG9TzjQMzajF7wFucLGMiEghWagC/Qg4m4LqCcYapJeBrvGE38qQxdifGMEaHS9eBFrCX/uoqq9YorXOILQzXwNlqS+EomNEmuYRwJxV3GZAMYnjKhw1KVkiQfDWA4K+IQS6pvohS/10KP1IO/cZDhFvt1AkrY/AcWmdu8E1dw9k9gPZ1H5u8xVTCLXfw0AH/iznORqXqNFaFgg9jCAz6FW7iL3pDQwh859AtPVUM91nCdggAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/已去过.png
// module id = G08O
// module chunks = 1